import DentistList from '@/views/dentist/List.vue'
import DentistCreate from '@/views/dentist/Create.vue'
import DentistManage from '@/views/dentist/Manage.vue'
import DentistUserCreate from '@/views/dentist/user/Create.vue'
import DentistUserManage from '@/views/dentist/user/Manage.vue'
import DentistPracticeView from '@/views/dentist/practice/View.vue'
import DentistPracticeUpdate from '@/views/dentist/practice/Update.vue'
import DentistAvailabilityView from '@/views/dentist/availability/View.vue'
import DentistAvailabilityUpdate from '@/views/dentist/availability/Update.vue'
import DentistInfo from '@/views/dentist/Info.vue'

export default [
  // Shared Routes
  // Dentist List - Admin, Operator
  {
    path: '/dl',
    name: 'dentist-list',
    component: DentistList,
    meta: {
      auth: ['admin', 'operator'],
      breadcrumbs: [
        {
          link: 'dentist-list',
          title: 'Dentist List'
        }
      ],
      topbarGroup: 'users'
    }
  },

  // Routes for Admins
  {
    path: '/dc',
    name: 'dentist-create',
    component: DentistCreate,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'dentist-list',
          title: 'Dentists'
        },
        {
          link: 'dentist-create',
          title: 'Dentist Create',
          params: 'id'
        }
      ],
      topbarGroup: 'users'
    }
  },
  {
    path: '/dm/:id',
    name: 'dentist-manage',
    component: DentistManage,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'dentist-list',
          title: 'Dentists'
        },
        {
          link: 'dentist-manage',
          title: 'Dentist Manage',
          params: 'id'
        }
      ],
      topbarGroup: 'users'
    }
  },
  {
    path: '/duc/:id',
    name: 'dentist-user-create',
    component: DentistUserCreate,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'dentist-list',
          title: 'Dentists'
        },
        {
          link: 'dentist-manage',
          title: 'Dentist Manage',
          params: 'id'
        },
        {
          link: 'dentist-user-create',
          title: 'Dentist Add User',
          params: 'id'
        }
      ],
      topbarGroup: 'users'
    }
  },
  {
    path: '/dum/:dentist/:user',
    name: 'dentist-user-manage',
    component: DentistUserManage,
    meta: {
      auth: ['admin'],
      breadcrumbs: [
        {
          link: 'dentist-list',
          title: 'Dentists'
        },
        {
          link: 'dentist-manage',
          title: 'Dentist Manage',
          params: { id: 'dentist' }
        },
        {
          link: 'dentist-user-manage',
          title: 'Dentist Manage User',
          params: { dentist: 'dentist', user: 'user' }
        }
      ],
      topbarGroup: 'users'
    }
  },

  // Routes for Operators
  {
    path: '/di/:id?',
    name: 'dentist-info',
    component: DentistInfo,
    meta: {
      auth: ['operator'],
      breadcrumbs: [
        {
          link: 'dentist-list',
          title: 'Dentist List'
        },
        {
          link: 'dentist-info',
          title: 'Dentist Info',
          params: 'id'
        }
      ]
    }
  },

  // Routes for Dentists
  {
    path: '/dpv',
    name: 'dentist-practice-view',
    component: DentistPracticeView,
    meta: {
      auth: ['dentist'],
      breadcrumbs: [
        {
          link: 'dentist-practice-view',
          title: 'Practice'
        }
      ]
    }
  },
  {
    path: '/dpu',
    name: 'dentist-practice-update',
    component: DentistPracticeUpdate,
    meta: {
      auth: ['dentist'],
      breadcrumbs: [
        {
          link: 'dentist-practice-view',
          title: 'Practice'
        },
        {
          link: 'dentist-practice-update',
          title: 'Update Practice'
        }
      ]
    }
  },
  {
    path: '/dav',
    name: 'dentist-availability-view',
    component: DentistAvailabilityView,
    meta: {
      auth: ['dentist'],
      breadcrumbs: [
        {
          link: 'dentist-availability-view',
          title: 'Availability'
        }
      ]
    }
  },
  {
    path: '/dau',
    name: 'dentist-availability-update',
    component: DentistAvailabilityUpdate,
    meta: {
      auth: ['dentist'],
      breadcrumbs: [
        {
          link: 'dentist-availability-view',
          title: 'Availability'
        },
        {
          link: 'dentist-availability-update',
          title: 'Update availability'
        }
      ]
    }
  }
]
